import { appInit } from "./app/init.js";
import { onDocumentLoaded } from "./utils/on-document-loaded.js";

import "swiper/css";

onDocumentLoaded(appInit);